import { useState } from 'react';
import { BankAccountApi } from '@recargas-dominicanas/core/api';
import { DateTime, TextField } from '@recargas-dominicanas/core/components';
import { useForm, validators } from '@recargas-dominicanas/core/utils';
import { Modal } from '../../../components/modal/modal.component';
import { BankAccountStore } from '../../../store/bankAccountStore';
import { BusinessSelect } from '../../../components/business-select/business-select.component';
import { style } from './register-deposit-modal.module.css';

interface Props {
  open: boolean;
  bankAccountId: number;
  onClose: () => void;
}

export function RegisterDepositModal(props: Props) {

  const {
    open,
    bankAccountId,
    onClose
  } = props;

  const [error, setError] = useState<string>();
  const [disabledButton, setDisabledButton] = useState(false);

  const form = useForm({
    date: '' as string | undefined,
    balance: '',
    businessId: '',
    reference: ''
  });

  function handleCancel() {
    form.clear();
    onClose();
    setError(undefined);
  }

  async function handleSave() {
    
    if (!form.isValid()) return;

    setDisabledButton(true);

    try {

      await BankAccountApi.registerDeposit(bankAccountId, {
        balance: parseInt(form.value.balance),
        date: new Date(form.value.date!),
        businessId: form.value.businessId ? parseInt(form.value.businessId) : undefined,
        reference: form.value.reference
      });

      BankAccountStore.fetchById(bankAccountId);
      BankAccountStore.fetchDeposits(bankAccountId, 1, 100);

      handleCancel();

    } catch {

      setError('Ocurrio un error al registrar el deposito');
    }

    setDisabledButton(false);
  }

  return (
    <Modal
      open={open}
      style={style.modal}
      title='Registrar deposito'
      error={error}
      secondaryButton='Registrar'
      disabledSecondaryButton={disabledButton}
      onClose={handleCancel}
      onSecondaryClick={handleSave}>
      <TextField
        style={style.textField}
        label='Balance'
        type='number'
        formField={form.fields.balance}
        validators={[validators.required]}/>
      <DateTime
        style={style.dateTime}
        label='Fecha'
        placeholder='Seleccionar fecha'
        type='datetime-local'
        formField={form.fields.date}
        required={true}/>
      <TextField
        style={style.textField}
        label='Descripción'
        formField={form.fields.reference}/>
      <BusinessSelect
        className={style.businessSelect}
        label='Asignar a'
        icon='storefront'
        placeholder='Seleccionar negocio'
        field={form.fields.businessId}/>
    </Modal>
  );
}
